import * as React from "react";
import plusbig from "src/assets/images/plus-big.png";
import { useState, useEffect } from "react";
import Modal from "../../../component/Global/Modal";
import System from "../../../helper/system";
import { useCartStore } from "../../../hooks/cart";
import $ from "jquery";
import { useDOMAttachToSystemStore } from "src/hooks/domAttachToSystem";

const ShippingAddressPopup = (props) => {
  const [
    { CART_SHIPPING_ADDRESS_ID, SHIPPING_ADDRESS_LIST },
    { shipping_address_list },
    { shipping_address_id, default_shipping_address_id, SET_SELECTED_SHIPPING_ADDRESS },
  ] = useCartStore();

  const [defaultAddressId, setDefaultAddressId] = useState(null);
  const [shipToAddressId, setShipToAddressId] = useState(0);
  const [status, SetStatus] = useState(false);
  const [{ ShippingAddressPopup }, { }, { }] = useDOMAttachToSystemStore();

  useEffect(() => {
    if (System.getParams().ShippingAddressPopup === "1") {
      SetStatus(true);
    } else if (ShippingAddressPopup) {
      SetStatus(true);
    }
  }, [ShippingAddressPopup]);

  const onHide = (action = true) => {
    SetStatus(false);
    setShipToAddressId(0);
    setDefaultAddressId(null);
    let c = System.getParams();
    delete c.ShippingAddressPopup;
    history.pushState(null, null, "?" + $.param(c));
  };

  useEffect(() => {
    async function fetchHere() {
      /*
      * Name: Hardik Sarodiya 
      * Comment: Multiple API Call Issue.
      */
      if (SHIPPING_ADDRESS_LIST && SHIPPING_ADDRESS_LIST.length > 0) {
        await SHIPPING_ADDRESS_LIST.map((res) => {
          if (res.isDefault) {
            setDefaultAddressId(res.shipToAddressId);
          }
        });

      }
      // else {
      //   await fetchFromServer();
      // }

      if (CART_SHIPPING_ADDRESS_ID) {
        setShipToAddressId(CART_SHIPPING_ADDRESS_ID);
      }
    }

    if (status) {
      fetchHere();
    }
  }, [status, JSON.stringify(SHIPPING_ADDRESS_LIST), CART_SHIPPING_ADDRESS_ID]);


  const fetchFromServer = async () => {
    await shipping_address_list()
  };

  const applyChanges = async () => {
    await default_shipping_address_id(defaultAddressId);
    SET_SELECTED_SHIPPING_ADDRESS(SHIPPING_ADDRESS_LIST, shipToAddressId)
    onHide();
    await shipping_address_id(shipToAddressId);
  };

  return (
    <>
      <Modal show={status} onHide={() => { onHide(); }}      >
        <div className="avnet-modal modal-630">
          <div className="avnet-modal-inner">
            <button type="button" className="close py-3" data-dismiss="modal"
              onClick={() => { onHide(); }} > × </button>
            <div className="modal-header">
              <h3 className="modal-title text-center" id="exampleModalLongTitle"              >
                Select Ship To Address
              </h3>
            </div>
            <div className="modal-body">
              <div className="bs5 row g-3">
                {(SHIPPING_ADDRESS_LIST !== undefined && SHIPPING_ADDRESS_LIST.length > 0) &&
                  SHIPPING_ADDRESS_LIST.map((v, i) => (
                    <React.Fragment key={v.shipToAddressId}>
                      <div className="col-md-6 mb-3">
                        <div className="shipping-address-div">
                          <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios"
                              id={`check${v.shipToAddressId}`}
                              checked={v.shipToAddressId === shipToAddressId}
                              onChange={(e) => {
                                e.stopPropagation();
                                setShipToAddressId(v.shipToAddressId);
                              }}
                              value={v.shipToAddressId}
                            />
                            <label className="form-check-label" htmlFor={`check${v.shipToAddressId}`}>
                              <b>{v.name && v.name.trim() !== '' ? v.name : ''}</b>
                              <span>
                                {v.addressLine && v.addressLine.trim() !== '' ? v.addressLine : ''}
                                <br /> {v.postalCode && v.postalCode.trim() !== '' ? v.postalCode : ''} {v.countrySubDivisionCode && v.countrySubDivisionCode.trim() !== '' ? v.countrySubDivisionCode : ''}
                                <br /> {v.cityName && v.cityName.trim() !== '' ? v.cityName : ''}, {v.countryCode && v.countryCode.trim() !== '' ? v.countryCode : ''}
                              </span>
                            </label>
                          </div>
                          <div className="form-check form-check-reverse mb-0">
                            <label className="form-check-label" htmlFor={`customCheck${v.shipToAddressId}`} >
                              Make Default
                            </label>
                            <input type="checkbox" className="form-check-input"
                              id={`customCheck${v.shipToAddressId}`} name={`customCheck${v.shipToAddressId}`}
                              checked={v.shipToAddressId == defaultAddressId ? true : false}
                              value={v.shipToAddressId}
                              onChange={(e) => {
                                e.stopPropagation();
                                if (!defaultAddressId) {
                                  setDefaultAddressId(e.target.value);
                                } else if (e.target.value == defaultAddressId) {
                                  setDefaultAddressId(null);
                                } else {
                                  setDefaultAddressId(null);
                                  setDefaultAddressId(e.target.value);
                                }
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  ))}
                <div className="col-md-6 mb-3">
                  <div className="add-shipping-address m-0">
                    <a> <img src={plusbig} /> </a>
                    <p>
                      In order to add a new address. Please <br />
                      contact your account representative.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer text-center">
              <button className="bs5 btn btn-secondary btn-sm btn-sm w145" data-dismiss="modal"
                onClick={() => {
                  onHide();
                }}>cancel</button>
              <button type="button" className="bs5 btn btn-primary btn-sm w145"
                disabled={!shipToAddressId}
                onClick={async () => { await applyChanges(); }}
              >submit</button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ShippingAddressPopup;
